import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Commodity_CommodityWaitListOptionRequestModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type AddCommodityWaitListOption = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestModels_Commodity_CommodityWaitListOptionRequestModel;
};
/**
 * Adds the commodity wait list opiont.
 *
 * @returns any Success
 */
export function addCommodityWaitListOption(
  { businessUnit, label, requestBody }: AddCommodityWaitListOption,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/commodity/waitlistoption`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
